/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(function (algolia) {
  "use strict";
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;
  var aa = algolia.externals.aa;

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];
  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }
    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);
    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  // On collection pages we do NOT filter out out-of-stock products so we can show them with a sold-out badge
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy && !collectionPageEnabled) {
    if (algolia.config.stock_policy === "allow") {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === "deny") {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = "inventory_quantity > 0";
    } else if (algolia.config.stock_policy === "continue") {
      /**
       * For 'continue' we filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = "inventory_available:true";
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ", .algolia-shopify-instantsearch";

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function (k) {
      if (k === "configure" || k === "query" || k === "q") {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function (uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function (routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (
            acc,
            key,
          ) {
            acc[key] = routeState[key];
            return acc;
          },
          {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var client = algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key,
  );

  const imageHoverFind = (images) => {
    let image = images[images.length - 1];
    image = image.split(".jpg");
    image = `${image[0]}_large.jpg${image[1]}`;
    return image;
  };

  const customSearchClient = {
    search: function (requests) {
      return client.search(requests).then(async (result) => {
        const { hits } = result.results[0];
        return Promise.all(
          hits.map(async (hit) => {
            const data = await fetch(
              `${window.Shopify.routes.root}products/${hit.handle}.js`,
            )
              .then((response) => response.json())
              .then((data) => data);
            hit.price = data["price"] / 100;
            hit.compare_at_price = USMarket
              ? hit.meta.cosette.usd_compare_at_price
              : data["compare_at_price"] / 100;
            hit.price_ratio = hit.price / hit.compare_at_price;
            hit.secondImage = imageHoverFind(data.images);
          }),
        ).then(() => result);
      });
    },
  };

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key,
      ),
      indexName: algolia.config.index_prefix + "products",
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + "products"),
      },
      searchFunction: function (searchFunctionHelper) {
        
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter("distinct", true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            "filters",
            searchFilters.join(" AND "),
          );
        }
        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        var currentIndexName = algolia.config.index_prefix + "products";


        if (searchFunctionHelper.state.index && searchFunctionHelper.state.index != 'prod_products') {
          searchFunctionHelper.setQueryParameter("ruleContexts", []);
        }

        if (searchFunctionHelper.state.index && searchFunctionHelper.state.index == 'prod_products') {
          
          if (collectionPageEnabled) {
            // Collection page merchandising:
            // If we are on a collection page, `collectionRulesContextValue` is defined
            if (collectionRulesContextValue && !USMarket) {
              searchFunctionHelper.setQueryParameter("ruleContexts", [
                collectionRulesContextValue.toString(),
                "cosette-default",
                `market-${CosetteMarket.active_country}`,
              ]);
            } else if (collectionRulesContextValue && USMarket) {
              searchFunctionHelper.setQueryParameter("ruleContexts", [
                collectionRulesContextValue.toString(),
                "cosette-default-us",
                "cosette-default",
                `market-${CosetteMarket.active_country}`,
              ]);
            } else {
              searchFunctionHelper.setQueryParameter("ruleContexts", [
                "cosette-default",
                USMarket ? "cosette-default-us" : "",
                `market-${CosetteMarket.active_country}`,
              ]);
            }
          }
          
          
          if (!algolia.is_collection_results_page && searchFunctionHelper.state.index && searchFunctionHelper.state.index.startsWith("prod_products")) {
            searchFunctionHelper.setQueryParameter("ruleContexts", [
              "cosette-default",
              USMarket ? "cosette-default-us" : "",
              `market-${CosetteMarket.active_country}`,
            ]);
          }
        } else {
        }
        
        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
        
      },
    }),
    selector: results_selector + ", .algolia-shopify-instantsearch",
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate(
        "instant_search_current_refined_values_item",
      ),
      empty: algolia.getTemplate("instant_search_no_result"),
      page: algolia.compileTemplate("instant_search"),
      product: algolia.getTemplate("instant_search_product"),
      stats: algolia.getTemplate("instant_search_stats"),
      style: algolia.compileTemplate("instant_search.css"),
    },
  };

  algolia.instantsearch = instant;

  function readjust() {
    var width = instant.$results.offsetWidth;
    var suffix = "lg";
    if (width < 400) suffix = "xs";
    else if (width < 700) suffix = "sm";
    else if (width < 1200) suffix = "md";

    instant.$results.classList.remove("ais-results-size-xs");
    instant.$results.classList.remove("ais-results-size-sm");
    instant.$results.classList.remove("ais-results-size-md");
    instant.$results.classList.remove("ais-results-size-lg");
    instant.$results.classList.add("ais-results-size-" + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers,
  );
  Object.keys(helpers).forEach(function (name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    }),
  );

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        "Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector",
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      "Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector",
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener("resize", function () {
    readjust();
  });

  // Mobile facets display
  instant.search.addWidgets([
    {
      init: function () {
        var $button = document.querySelector(".ais-facets-button");
        $button.addEventListener("click", function () {
          var $facets = document.querySelector(".ais-facets");

          if ($facets.classList.contains("ais-facets__shown")) {
            $button.textContent = "Show filters";
            $facets.classList.remove("ais-facets__shown");
          } else {
            $button.textContent = "Hide filters";
            $facets.classList.add("ais-facets__shown");
          }
        });
      },
    },
  ]);

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: ".ais-search-box-container",
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function (opts) {
        if (!instant.poweredBy) {
          document.querySelector(".ais-algolia-icon").style.display = "none";
        }
        document
          .querySelector(".ais-clear-input-icon")
          .addEventListener("click", function () {
            opts.helper.setQuery("").search();
            var input = document.querySelector(".ais-search-box--input");
            input.value = "";
            input.focus();
          });
      },
      render: function (opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) {
            document.querySelector(".ais-algolia-icon").style.display = "";
          }
          document.querySelector(".ais-clear-input-icon").style.display =
            "none";
        } else {
          document.querySelector(".ais-clear-input-icon").style.display = "";
          document.querySelector(".ais-algolia-icon").style.display = "none";
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: ".ais-stats-container",
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: ".ais-sort-orders-container",
        items: instant.sortOrders,
      }),
    ]);
  }

  // Modern Dropdown Enhancement
  instant.search.addWidgets([
    {
      init: function() {
        // Wait for the sort dropdown to be rendered
        setTimeout(function() {
          enhanceSortDropdown();
        }, 100);
      },
      render: function() {
        // Re-enhance after each render
        setTimeout(function() {
          enhanceSortDropdown();
        }, 50);
      }
    }
  ]);

  function enhanceSortDropdown() {
    const sortContainer = document.querySelector('.ais-sort-orders-container');
    if (!sortContainer) return;

    const originalSelect = sortContainer.querySelector('.ais-SortBy-select');
    if (!originalSelect) return;

    // Skip if already enhanced
    if (sortContainer.querySelector('.modern-dropdown')) return;

    // Create modern dropdown structure
    const modernDropdown = document.createElement('div');
    modernDropdown.className = 'modern-dropdown';
    
    const trigger = document.createElement('div');
    trigger.className = 'modern-dropdown-trigger';
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    
    const triggerText = document.createElement('span');
    triggerText.className = 'dropdown-text';
    triggerText.textContent = originalSelect.options[originalSelect.selectedIndex].textContent;
    
    const triggerIcon = document.createElement('span');
    triggerIcon.className = 'dropdown-icon';
    triggerIcon.innerHTML = '▼';
    
    trigger.appendChild(triggerText);
    trigger.appendChild(triggerIcon);
    
    const menu = document.createElement('div');
    menu.className = 'modern-dropdown-menu';
    menu.setAttribute('role', 'listbox');
    
    // Create menu items
    Array.from(originalSelect.options).forEach((option, index) => {
      const item = document.createElement('div');
      item.className = 'modern-dropdown-item';
      if (option.selected) item.classList.add('selected');
      item.setAttribute('role', 'option');
      item.setAttribute('data-value', option.value);
      item.setAttribute('tabindex', '0');
      
      const itemText = document.createElement('span');
      itemText.textContent = option.textContent;
      
      item.appendChild(itemText);
      menu.appendChild(item);
    });
    
    modernDropdown.appendChild(trigger);
    modernDropdown.appendChild(menu);
    
    // Replace the original select with modern dropdown
    sortContainer.innerHTML = '';
    sortContainer.appendChild(modernDropdown);
    
    // Add event listeners
    let isOpen = false;
    
    function toggleDropdown() {
      isOpen = !isOpen;
      trigger.classList.toggle('active', isOpen);
      menu.classList.toggle('show', isOpen);
      trigger.setAttribute('aria-expanded', isOpen.toString());
      
      if (isOpen) {
        // Focus first item when opening
        const firstItem = menu.querySelector('.modern-dropdown-item');
        if (firstItem) firstItem.focus();
      }
    }
    
    function closeDropdown() {
      isOpen = false;
      trigger.classList.remove('active');
      menu.classList.remove('show');
      trigger.setAttribute('aria-expanded', 'false');
    }
    
    function selectOption(item) {
      const value = item.getAttribute('data-value');
      const text = item.textContent.trim();
      
      // Update the original select (if it still exists)
      if (originalSelect) {
        originalSelect.value = value;
        originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Update the trigger text
      triggerText.textContent = text;
      
      // Update selected state
      menu.querySelectorAll('.modern-dropdown-item').forEach(menuItem => {
        menuItem.classList.remove('selected');
      });
      item.classList.add('selected');
      
      closeDropdown();
    }
    
    // Event listeners
    trigger.addEventListener('click', toggleDropdown);
    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDropdown();
      } else if (e.key === 'Escape') {
        closeDropdown();
      }
    });
    
    menu.addEventListener('click', function(e) {
      const item = e.target.closest('.modern-dropdown-item');
      if (item) {
        selectOption(item);
      }
    });
    
    menu.addEventListener('keydown', function(e) {
      const items = Array.from(menu.querySelectorAll('.modern-dropdown-item'));
      const currentIndex = items.indexOf(document.activeElement);
      
      switch(e.key) {
        case 'ArrowDown':
          e.preventDefault();
          const nextIndex = (currentIndex + 1) % items.length;
          items[nextIndex].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          const prevIndex = currentIndex <= 0 ? items.length - 1 : currentIndex - 1;
          items[prevIndex].focus();
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          selectOption(document.activeElement);
          break;
        case 'Escape':
          closeDropdown();
          trigger.focus();
          break;
      }
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!sortContainer.contains(e.target)) {
        closeDropdown();
      }
    });
    
    // Close dropdown on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) {
        closeDropdown();
        trigger.focus();
      }
    });
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function () {
        document
          .querySelector(".ais-search-header .ais-change-display-block")
          .addEventListener("click", function () {
            document
              .querySelector(
                ".ais-change-display-block:not(.ais-change-display-selected)",
              )
              .classList.add("ais-change-display-selected");
            document
              .querySelector(
                ".ais-change-display-list.ais-change-display-selected",
              )
              .classList.remove("ais-change-display-selected");
            document
              .querySelector(".ais-results-as-list")
              .classList.replace("ais-results-as-list", "ais-results-as-block");
          });
        document
          .querySelector(".ais-search-header .ais-change-display-list")
          .addEventListener("click", function () {
            document
              .querySelector(
                ".ais-change-display-list:not(.ais-change-display-selected)",
              )
              .classList.add("ais-change-display-selected");
            document
              .querySelector(
                ".ais-change-display-block.ais-change-display-selected",
              )
              .classList.remove("ais-change-display-selected");
            document
              .querySelector(".ais-results-as-block")
              .classList.replace("ais-results-as-block", "ais-results-as-list");
          });
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function (facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function () {},
    },
  ]);

  // Create the render function
  var createDataAttribtues = function (refinement) {
    return Object.keys(refinement)
      .map(function (key) {
        return "data-" + key + '="' + refinement[key] + '"';
      })
      .join(" ");
  };

  function capitalize(stringToCapitalize) {
    return stringToCapitalize[0].toUpperCase() + stringToCapitalize.slice(1);
  }

  var renderListItem = function (item) {
    var facet = instant.facets.list.find(function (f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function (refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          "  <a " +
          createDataAttribtues(refinement) +
          '    class="ais-current-refined-values--link">' +
          "    <div>" +
          '      <div class="ais-current-refined-values--label">' +
          capitalize(facet.title) +
          "      </div>: " +
          capitalize(refinement.label.replace(/[\[\]"]+/g, "")) +
          "    </div>" +
          "  </a>" +
          "</li>"
        );
      })
      .join("");
  };

  var renderCurrentRefinements = function (renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-current-refined-values--header ais-facet--header ais-header">SHOPPING BY:</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join("") +
      "  </ul>" +
      "</div>";

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          ".ais-current-refined-values--link",
        ),
      )
      .forEach(function (element) {
        element.addEventListener("click", function (event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function (
            acc,
            key,
          ) {
            var itemData = {};
            itemData[key] = event.currentTarget.dataset[key];
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements,
  );

  var hasRefinements = function (helper, facetsList) {
    return facetsList.some(function (f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(
        function (operator) {
          return numericRefinements[operator].length > 0;
        },
      );

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function (resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function (facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function (facet) {
        return facet.name === facetName;
      },
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function (facet) {
        return facet.name === facetName;
      },
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector(".ais-clear-refinements-container"),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        ".ais-current-refined-values-container",
      ),
    }),
  ]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function (widget) {
    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? "none" : "";

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName =
          ".ais-facet-" +
          encodeURIComponent(widget.params.attribute)
            .replace(/\./g, "\\.")
            .replace(/\%/g, "\\%");
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  // Hits
  const imageHover = (json) => {
    let variantId;
    let box;
    let i = 0;
    while (!box || i <= json.variants.length) {
      let variantId = json.variants[i].id;
      box = $(`[data-algolia-objectid="${variantId}"]`);
      if (box.length) break;
      i++;
    }
    const secondImage = $(`<img class="tt-img-product hidden-image" loading="lazy" src="${json.images[json.images.length - 1]}" alt="${json.title}" height="480" width="360"/>`);

    secondImage.appendTo(box.find(".tt-image-container"));

    if(json.tags.includes("tlx") && !json.tags.includes("ignore-styling")) {
      box.find(".tt-image-container").addClass("TLX");
    }
  };

  /**
   * Label above vendor in instant search: Perfect Imperfection vs Pre Loved from collection membership (or tags fallback).
   */
  const COLLECTION_PERFECT_IMPERFECTION = "perfect-imperfection";
  const COLLECTION_PRE_LOVED = "pre-loved";
  const TAG_PERFECT_IMPERFECTION = "perfectimperfection";
  const TAG_PRE_LOVED = "pre-loved";

  const normalizeCollectionHandles = (product) => {
    var raw = product.collections;
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw.map(function (h) {
        return String(h).toLowerCase();
      });
    }
    return [];
  };

  const tagLabelFromProduct = (product, productTags) => {
    var handles = normalizeCollectionHandles(product);
    var tagsLower = (productTags || []).map(function (t) {
      return String(t).toLowerCase();
    });
    if (
      handles.indexOf(COLLECTION_PERFECT_IMPERFECTION) !== -1 ||
      tagsLower.indexOf(TAG_PERFECT_IMPERFECTION) !== -1
    ) {
      return { title: "PERFECT IMPERFECTION", color: "#f32a44" };
    }
    if (
      handles.indexOf(COLLECTION_PRE_LOVED) !== -1 ||
      tagsLower.indexOf(TAG_PRE_LOVED) !== -1
    ) {
      return { title: "PRE LOVED", color: "#f32a44" };
    }
    return { title: "", color: "#f32a44" };
  };

  const filterCollectionTag = (product, wantColor) => {
    var productTags = product.tags || [];
    var attrs = tagLabelFromProduct(product, productTags);
    if (!attrs.title) return "";
    return wantColor ? attrs.color : attrs.title;
  };

  const usdConversion = (price) =>
    ((Number(price) / 1.1) * Shopify.currency.rate).toFixed(2);

  const priceBuild = (product) => {
    let price = product.price;
    if (USMarket && product.meta.cosette) {
      price = product.meta.cosette.usd_price
        ? product.meta.cosette.usd_price
        : usdConversion(product.price);
    }
    return price;
  };

  const compareatpriceBuild = (product) => {
    let price = product.compare_at_price;

    if (USMarket && product.meta.cosette) {
      price = product.meta.cosette.usd_compare_at_price
        ? product.meta.cosette.usd_compare_at_price
        : usdConversion(product.compare_at_price);

      if (
        product.meta.cosette.usd_compare_at_price > 0 &&
        product.meta.cosette.usd_price == undefined
      ) {
        price = usdConversion(product.compare_at_price);
      }
    }
    return price;
  };

  const sessionStorageCache = instantsearch.createInfiniteHitsSessionStorageCache();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  
  instant.search.addWidgets([
    window.instantsearch.widgets.infiniteHits({
      container: ".ais-hits-container",
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
        showMoreText: function () {
          return `<span class="btn btn btn-lg btn-addtocart ais-InfiniteHits-loadMoreText">Show More</span>`;
        },
      },
      cssClasses: {
        list: "MyCustomHitsList",
      },
      transformItems: function (products) {
        return products.map(function (product) {
          // Check if product has flash-sale tag
          var productTags = product.tags || [];
          var hasFlashSale = Array.isArray(productTags) && productTags.some((e) => e === "flash-sale");
          var hasInhouse = Array.isArray(productTags) && productTags.some((e) => e === "inhouse");
          
          // Check if this variant is one of the belt variants that should show BELT20 code
          var belt20VariantIds = ["53172585365872", "52629943517552", "32983723212900", "51745877328240", "51745871593840", "53167391310192"];
          var hasBelt20 = belt20VariantIds.includes(String(product.objectID)) || belt20VariantIds.includes(String(product.variant_id));
          
          // Check if this variant is one of the reedition variants that should show REEDITION100 code
          var reedition100VariantIds = ["52516926194032", "33025313669220"];
          var hasReedition100 = reedition100VariantIds.includes(String(product.objectID)) || reedition100VariantIds.includes(String(product.variant_id));
          
          // FURTHER REDUCED: Prada Re-Edition 2005 Nylon Bag, Cleo Brushed Leather Shoulder Bag, Burberry, Cire Trudon, Ray-Ban / Ray Ban / RayBay (case-insensitive)
          var title = (product.title || '').toString();
          var vendor = (product.vendor || '').toString();
          var vendorLower = vendor.toLowerCase();
          var hasFurtherReduced = title.indexOf('Prada Re-Edition 2005 Nylon Bag') !== -1 ||
            title.indexOf('Cleo Brushed Leather Shoulder Bag') !== -1 ||
            vendor.indexOf('Burberry') !== -1 ||
            vendor.indexOf('Trudon') !== -1 ||
            vendorLower.indexOf('ray ban') !== -1 ||
            vendorLower.indexOf('ray-ban') !== -1 ||
            vendorLower.indexOf('rayban') !== -1 ||
            vendorLower.indexOf('raybay') !== -1;
          
          // Metafields are not in Algolia index, will be fetched via API after render
          var flashSaleMetafield = "";
          
          // Sold-out logic: same as product detail page (product_page_1_description.liquid)
          // Product page uses product.available (Liquid); here we have one variant per hit.
          // Shopify variant.available = can sell when: not tracking inventory OR allow backorder OR qty > 0
          var qty = Number(product.inventory_quantity);
          var isTrackingInventory = product.inventory_management === "shopify" || product.inventory_management === "shopify_hidden";
          var allowBackorder = product.inventory_policy === "continue";
          var variantCanOrder =
            !isTrackingInventory ||
            allowBackorder ||
            (qty > 0);
          // Use index flags if present (Algolia may send available / inventory_available), else use variant rule
          var isProductAvailable = false;
          if (product.product_type === "Gift Card") {
            isProductAvailable = true;
          } else if (typeof product.available !== "undefined") {
            isProductAvailable = Boolean(product.available);
          } else if (typeof product.inventory_available !== "undefined") {
            isProductAvailable = Boolean(product.inventory_available);
          } else {
            isProductAvailable = variantCanOrder;
          }
          
          return algolia.assign({}, product, {
            _distinct: false,
            can_order: variantCanOrder,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            tags: filterCollectionTag(product, false),
            colorTags: filterCollectionTag(product, true),
            has_flash_sale: hasFlashSale ? 1 : 0,
            has_inhouse: hasInhouse ? 1 : 0,
            has_belt20: hasBelt20 ? 1 : 0,
            has_reedition100: hasReedition100 ? 1 : 0,
            has_further_reduced: (hasFurtherReduced && isProductAvailable) ? 1 : 0,
            has_sold_out: isProductAvailable ? 0 : 1,
            flash_sale_metafield: flashSaleMetafield,
            index: instant.search.mainIndex.getIndexName(),
            inventory_available: isProductAvailable,
            price: priceBuild(product),
            compare_at_price: compareatpriceBuild(product),
            secondImage: !isMobile? Shopify.getProduct(product.handle, imageHover): "",
          });
        });
      },
      cache: sessionStorageCache,
    }),
  ]);

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector(".ais-hits-container");
        container.addEventListener("click", function (e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches(".ais-hit")) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = "";

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = "/collections/" + collectionHandle;
          }

          // Add the product handle to the link
          link = link + "/products/" + productHandle;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== "true") {
            link += "?variant=" + variant_id;
          }

          if (algolia.config.analytics_enabled) {
            var clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: "click",
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };

            // Send the click event
            aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            // algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector(".ais-hits-container");
        container.addEventListener("click", function (e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches(".ais-hit--cart-button")) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function (opts) {
        var container = document.querySelector(".ais-hits-container");
        container.addEventListener("click", function (e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches(".ais-hit-empty--clear-filters")) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function (facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener("click", function (e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches(".ais-hit-empty--clear-input")) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery("").search();
          var input = document.querySelector(".ais-search-box--input");
          input.value = "";
          input.focus();
        });
      },
    },
  ]);

  // Pagination
  // instant.search.addWidgets([
  //   pagination({
  //     container: ".ais-pagination-container",
  //     padding: 1,
  //     maxPages: 40,
  //     showLast: false,
  //     showFirst: false,
  //     templates: {
  //       previous: "<&nbsp;&nbsp;&nbsp;Previous",
  //       next: "Next&nbsp;&nbsp;&nbsp;>",
  //     },
  //   }),
  // ]);

  $(".ais-facets-title").click(function () {
    $(this)
      .parent()
      .find(".ais-facets-container")
      .toggleClass("ais-display-toogle");
    $(this).toggleClass("facets-minus-icon");
  });


  const sentinel = document.createElement('div');
  sentinel.className = 'infinite-scroll-sentinel';

  const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          const lastResults = instant.search.helper.lastResults;  
          const currentpage = instant.search.helper.getCurrentPage();
          const lastpage =  currentpage+1 === lastResults.nbPages;
            if (!lastpage && currentpage < 2) {
                instant.search.helper.nextPage().search();
            }
        }
    });

  
  // GTM Trigger analizify event
  instant.search.on("render", (param) => {
    document.querySelector('.ais-hits-container').appendChild(sentinel); 
    observer.observe(sentinel);
    if (!instant.search.helper.lastResults) return;
    if (typeof analizifyAlgoliaHandle !== 'undefined') {
      analizifyAlgoliaHandle(instant.search.helper.lastResults.hits);
    }
    
    // Fetch and display flash_sale metafield for each product
    var productElements = document.querySelectorAll('.ais-hit');
    
    productElements.forEach(function(productEl) {
      var handle = productEl.getAttribute('data-handle');
      
      if (!handle) {
        return;
      }
      
      if (productEl.dataset.metafieldFetched) {
        return;
      }
      
      productEl.dataset.metafieldFetched = 'true';
      
      // Use product.getproduct endpoint which includes metafields
      fetch(`${window.Shopify.routes.root}products/${handle}?view=getproduct`)
        .then(function(response) { 
          if (!response.ok) {
            throw new Error("Failed to fetch product data");
          }
          return response.json(); 
        })
        .then(function(data) {
          // Get custom flash_sale metafield from the data
          var flashSaleMetafield = data.flash_sale || "";
          
          // Display metafield if it exists
          if (flashSaleMetafield) {
            var priceEl = productEl.querySelector('.ais-hit--price');
            
            if (priceEl) {
              // Check if already added
              var existing = productEl.querySelector('.flash-sale-metafield');
              if (existing) {
                return;
              }
              
              var metafieldEl = document.createElement('p');
              metafieldEl.className = 'flash-sale-metafield';
              metafieldEl.style.cssText = 'font-size: 13px; font-weight: 600; color: #ccc; margin-top: 5px;';
              metafieldEl.textContent = flashSaleMetafield;
              priceEl.parentNode.insertBefore(metafieldEl, priceEl.nextSibling);
            }
          }
        })
        .catch(function(error) {
          // Silently handle errors
        });
    });
  });

  // Main
  instant.search.start();

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
